import { useEffect } from "react"

import CollapsibleTagList from "../../../components/CollapsibleTagList"
import useTradingCurrencies from "../hooks/useTradingCurrencies"
import { DatasetFilters } from "./types"

interface ICurrencyFilterProps {
  filters: DatasetFilters
  onFilterChange: (filters: { currencyCodeParam?: string[] }) => void
}

const CurrencyFilter = ({ filters, onFilterChange }: ICurrencyFilterProps) => {
  const { currencies } = useTradingCurrencies()

  useEffect(() => {
    onFilterChange({ currencyCodeParam: filters.currencyCodeParam })
  }, [filters, onFilterChange])

  return (
    <CollapsibleTagList
      title="Currencies"
      items={currencies ?? []}
      selectedItemIds={filters.currencyCodeParam
        ?.map(code => currencies?.find(currency => currency.code === code)?.id)
        .filter((id): id is number => id !== undefined)}
      onItemToggle={item => {
        if (filters.currencyCodeParam?.includes(item.code)) {
          onFilterChange({
            currencyCodeParam: filters.currencyCodeParam?.filter(code => code !== item.code),
          })
        } else {
          onFilterChange({
            currencyCodeParam: [...(filters.currencyCodeParam ?? []), item.code],
          })
        }
      }}
      onClear={() => onFilterChange({ currencyCodeParam: undefined })}
    />
  )
}

export default CurrencyFilter
